/**
 * Created by fd on 2021-09-22 (13:39).
 */
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/popup/info-mining.html";

const resourceIcons = require.context("Images/business-model/resource-icons", false, /\.svg$/);

require("Styles/components/popup/info-mining.scss");

class InfoMiningView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.event = options.event;

        options.html.find(".info-mode").hide();
        options.html.find(".feedback-mode").hide();

        options.html.find("." + options.mode + "-mode").show();

        if (options.mode === "feedback")
        {
            // options.html.find(".feedback-mode img").hide();

            let resources = options.data.data.resources;

            options.html.find(".feedback-mode").empty();

            for (let i = 0; i < resources["resource_red"]; ++i)
            {
                let img = $("<img src='" + resourceIcons("./resource_red.svg") + "' />");
                options.html.find(".feedback-mode").append(img);
            }

            for (let i = 0; i < resources["resource_yellow"]; ++i)
            {
                let img = $("<img src='" + resourceIcons("./resource_yellow.svg") + "' />");
                options.html.find(".feedback-mode").append(img);
            }

            for (let i = 0; i < resources["resource_purple"]; ++i)
            {
                let img = $("<img src='" + resourceIcons("./resource_purple.svg") + "' />");
                options.html.find(".feedback-mode").append(img);
            }

            let sum = resources["resource_red"] + resources["resource_yellow"] + resources["resource_purple"];
            if (sum === 1)
            {
                options.html.find(".feedback-mode.popup-message").attr("data-localize", "info.mining.feedback.single");
            }
            else
            {
                options.html.find(".feedback-mode.popup-message").attr("data-localize", "info.mining.feedback");
            }
        }
    }
}

module.exports = InfoMiningView;



// WEBPACK FOOTER //
// ./app/js/components/popup/info-mining.js